import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, get } from './constants';
import sx from './sx';
import theme from './theme';
function getBorderRadius(_ref) {
  let {
    size,
    square
  } = _ref;
  if (square) {
    return size && size <= 24 ? '4px' : '6px';
  } else {
    return '50%';
  }
}
const Avatar = styled.img.attrs(props => ({
  height: props.size,
  width: props.size
})).withConfig({
  displayName: "Avatar",
  componentId: "sc-1waaaky-0"
})(["display:inline-block;overflow:hidden;line-height:", ";vertical-align:middle;border-radius:", ";", ";", ""], get('lineHeights.condensedUltra'), props => getBorderRadius(props), COMMON, sx);
Avatar.defaultProps = {
  theme,
  size: 20,
  alt: '',
  square: false
};
Avatar.propTypes = {
  ...COMMON.propTypes,
  size: PropTypes.number,
  square: PropTypes.bool,
  ...sx.propTypes,
  theme: PropTypes.object
};
export default Avatar;